// Ankota embed session: .NET opens the app with ?token=<JWT> carrying { patientId, businessId, exp }.
// The browser can only DECODE the token (read its claims); checking the signature needs the secret,
// which must never ship to the browser, so that check belongs to the /fms API.

const STORAGE_KEY = 'fmsSessionToken';

function decodeJwt(token) {
    try {
        const [header, payload] = String(token).split('.').slice(0, 2).map(part =>
            JSON.parse(atob(part.replace(/-/g, '+').replace(/_/g, '/'))));
        if (header?.alg !== 'HS256') return null;
        return payload;
    } catch {
        return null;
    }
}

function readStored() {
    try { return sessionStorage.getItem(STORAGE_KEY); } catch { return null; }
}

function store(token) {
    try { sessionStorage.setItem(STORAGE_KEY, token); } catch { /* ignore */ }
}

// Runs once on load: take the token from the URL (or from earlier in this tab, so a refresh still
// works after the URL is cleaned), then strip it from the address bar so it doesn't sit in history
const urlParams = new URLSearchParams(window.location.search);
const urlToken = urlParams.get('token');
if (urlToken) {
    store(urlToken);
    urlParams.delete('token');
    const query = urlParams.toString();
    window.history.replaceState(window.history.state, '', `${window.location.pathname}${query ? `?${query}` : ''}${window.location.hash}`);
}

// A link that names its own patient (the old ?patientId= embed) replaces any token from earlier in this tab
const urlHasPatient = !!(urlParams.get('patientId') || urlParams.get('PatientId') || urlParams.get('patiendId'));
if (!urlToken && urlHasPatient) {
    try { sessionStorage.removeItem(STORAGE_KEY); } catch { /* ignore */ }
}

const sessionToken = urlToken || (urlHasPatient ? null : readStored());
const claims = sessionToken ? decodeJwt(sessionToken) : null;

/** 'none' (no token), 'invalid' (unreadable or not HS256), 'expired', or 'ok' */
export const sessionStatus = !sessionToken
    ? 'none'
    : !claims || !claims.patientId || !claims.businessId
        ? 'invalid'
        : Number(claims.exp) * 1000 <= Date.now()
            ? 'expired'
            : 'ok';

export const hasSessionToken = sessionStatus !== 'none';

/** IDs from the token, or null when there's no usable token */
export const sessionIds = sessionStatus === 'ok'
    ? { patientId: String(claims.patientId), businessId: String(claims.businessId) }
    : null;

/** Raw token, for sending to the API once /fms verifies it */
export const getSessionToken = () => (sessionStatus === 'ok' ? sessionToken : null);
